export const VIEWER_GUIDE_WRAPPER_ID = 'viewer_guide_wrapper';
export const VIEWER_GUIDE_FADE_IN_MS = 200;
